module.exports = __webpack_public_path__ + "img/Liqiang_Nie@2x.5e07d37d.png";